export default __webpack_public_path__ + "static/media/register-with-email.d51494f3.svg";